import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from "@angular/forms";
import {FolderModel} from "../../models/folder.model";

@Component({
  selector: 'edit-folder-modal',
  templateUrl: './edit-folder-modal.component.html',
  styleUrls: ['./edit-folder-modal.component.css']
})
export class EditFolderModalComponent implements OnInit {

  @Output() editFolderEvent = new EventEmitter<string>();
  @Output() closeEvent = new EventEmitter();
  @Output() folderChangedEvent = new EventEmitter();
  @Input() editFolderErrorMessage: String;
  @Input() currentFolder: FolderModel;
  folder = new FormControl('');

  constructor() { }

  ngOnInit() {
    this.folder.valueChanges.subscribe(value => {
      this.folderChangedEvent.emit();
    });
    this.folder.setValue(this.currentFolder.name);
  }

  editFolder(folder: string) {
    this.editFolderEvent.emit(folder);
  }

  cancel($event: MouseEvent) {
    if ($event.currentTarget === $event.target) {
      this.closeEvent.emit();
    }
  }
}
